








































import { Mixins, Component, Prop } from 'vue-property-decorator';
import ComponentPartCatalogListCard from '../common';
import MoreButton from '../components/More.vue';
import MorePrice from '../components/Price.vue';
import MoreTitle from '../components/Title.vue';
import MoreNote from '../components/Note.vue';
import MoreBadge from '@/components/parts/slider/badges/Badges.vue';
import Locked from '../components/Locked.vue';

@Component({
  components: {
    MoreTitle,
    MoreNote,
    MoreBadge,
    MorePrice,
    MoreButton,
    Locked,
  },
})
export default class ComponentPartCatalogListDouble extends Mixins(
  ComponentPartCatalogListCard,
) {
  hover = false;

  get stars() {
    return Array(5);
  }

  get kids() {
    const { max_person } = this;
    if (!max_person) return '';
    return parseInt(`${max_person}`, 10) === 1
      ? 'Индивидуально'
      : `до ${max_person} человек`;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/list/item/double/component.vue